export const STRIPO_EMAIL_TEMPLATES_EDITOR_ID = 'stripoEmailTemplatesEditor'
